import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-cart",
  "use": "icon-m-cart-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-cart\"><path d=\"m11.306 14 1.429 10H31.49l2.858-10zm.175 16.045L8.242 7H3V5h7v.138L10.964 12H37l-4 14H12.932l.562 4H31a3 3 0 1 1-2.83 2H14.83a3 3 0 1 1-3.349-1.955M12 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2m19 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol